import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'

export function useAppTranslations(): TFunction {
  const { t } = useTranslation(['translations'])
  return t
}
